export default __webpack_public_path__ + "static/claim_white-9f4ec6e8c073683f7fc73045c0c6156e.svg";